var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "prop-types", "../../propTypes", "../../UI/LandscapeImage/LandscapeImage"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"), require("../../propTypes"), require("../../UI/LandscapeImage/LandscapeImage"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.propTypes, global.LandscapeImage);
    global.TeaserEvent = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _propTypes, _propTypes2, _LandscapeImage) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _propTypes2 = _interopRequireDefault(_propTypes2);
  _LandscapeImage = _interopRequireDefault(_LandscapeImage);

  var TeaserEvent = function TeaserEvent(_ref) {
    var dateEvent = _ref.dateEvent,
        images = _ref.images,
        location = _ref.location,
        registration = _ref.registration,
        sharebar = _ref.sharebar,
        title = _ref.title,
        url = _ref.url;
    return /*#__PURE__*/_react.default.createElement("figure", {
      className: "club-teaser-event"
    }, /*#__PURE__*/_react.default.createElement(_LandscapeImage.default, {
      className: "club-teaser-event__image",
      images: images,
      title: title,
      url: url
    }), /*#__PURE__*/_react.default.createElement("figcaption", {
      className: "club-teaser-event__caption"
    }, url ? /*#__PURE__*/_react.default.createElement("a", {
      href: url
    }, /*#__PURE__*/_react.default.createElement("h1", {
      className: "club-teaser-event__title"
    }, title)) : /*#__PURE__*/_react.default.createElement("h1", {
      className: "club-teaser-event__title"
    }, title), location && /*#__PURE__*/_react.default.createElement("div", {
      className: "club-teaser-event__location"
    }, location), dateEvent && /*#__PURE__*/_react.default.createElement("div", {
      className: "club-teaser-event__date"
    }, dateEvent), /*#__PURE__*/_react.default.createElement("div", {
      className: "club-teaser-event__actions"
    }, registration, sharebar)));
  };

  TeaserEvent.propTypes = {
    dateEvent: _propTypes.default.string,
    images: _propTypes.default.arrayOf(_propTypes2.default.image).isRequired,
    location: _propTypes.default.string,
    registration: _propTypes.default.node,
    sharebar: _propTypes.default.node,
    title: _propTypes.default.string.isRequired,
    url: _propTypes.default.string
  };
  TeaserEvent.defaultProps = {
    dateEvent: '',
    images: [],
    location: '',
    title: '',
    url: ''
  };
  var _default = TeaserEvent;
  _exports.default = _default;
});